import PropTypes from "prop-types";
import React from "react";
import { Doughnut } from "react-chartjs-2";
export default function DoughnutChart({ chartData, ...props }) {
  const data = {
    labels: props.labels,
    datasets: [
      {
        data: chartData,
        backgroundColor: props.backgroundColor,
        hoverBackgroundColor: props.hoverBackgroundColor,
      }
    ]
  };

  return (
    <Doughnut data={data} options={props.options} {...props} />
  );
}

DoughnutChart.propTypes = {
  backgroundColor: PropTypes.array,
  hoverBackgroundColor: PropTypes.array,
  labels: PropTypes.array,
  chartData: PropTypes.array,
};

DoughnutChart.defaultProps = {
  backgroundColor: [
    "#f44336",
    "#e91e63",
    "#9c27b0",
    "#2196f3",
    "#ff5722",
    "#009688",
    "#3f51b5",
    "#fdd835",
    "#795548",
    "#689f38",
    "#b39ddb",
    "#81c784",
    "#ffe082",
    "#80deea",
    "#ce93d8",
    "#aed581",
    "#ffcc80",
    "#4dd0e1",
    "#9fa8da",
  ],
  hoverBackgroundColor: [
    "#d32f2f",
    "#c2185b",
    "#7b1fa2",
    "#1976d2",
    "#e64a19",
    "#00796b",
    "#303f9f",
    "#ffeb3b",
    "#795548",
    "#33691e",
    "#9c27b0",
    "#7cb342",
    "#ffb74d",
    "#26c6da",
    "#ba68c8",
    "#9ccc65",
    "#ffb74d",
    "#26c6da",
    "#7986cb",
  ],
  labels: [],
  chartData: []
};
